import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom"; // Added for structural isolation
import { useLocation } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";

const Portfolio = () => {
  const location = useLocation();
  const data = {
    Mobile: [
      {
        title: "LTC Embroidery Design",
        images: ["/images/1_ltc.png"],
        link: "https://play.google.com/store/apps/details?id=gnhub.ltc&hl=en_IN",
      },
      {
        title: "Etrend-Embroidery Design",
        images: ["/images/1-Etrend/2374-1.jpg"],
        link: "https://play.google.com/store/apps/details?id=com.lifetimecreation.embroideryPhotoImageDesignTrend2022_23&hl=en_IN",
      },
      {
        title: "Embroidery Machine Business",
        images: ["/images/2-EmbroideryBusiness/1.jpg"],
        link: "https://play.google.com/store/apps/details?id=com.lifetimeinfotech.embroideryMachineBusiness&hl=en_IN",
      },
      {
        title: "Embroidery Design Work Gallery",
        images: ["/images/3-EmbroideryDesignWorkGallery/1.jpg"],
        link: "https://play.google.com/store/apps/details?id=lifetimeinfotech.embroiderydesign.work_gallery&hl=en_IN",
      },
      {
        title: "Embroidery Design Studio-Photo",
        images: ["/images/4-EmbroideryDesignStudio/1.jpg"],
        link: "https://play.google.com/store/apps/details?id=embroidery.design.studio&hl=en_IN",
      },
      {
        title: "Hindu Gods HD Wallpapers",
        images: ["/images/6_AllHinduGodWallpaper.jpg"],
        link: "https://play.google.com/store/apps/details?id=lifetimeinfotech.all_hindu_gods.hd_wallpapers&hl=en_IN",
      },
      {
        title: "Jesus Christ HD Wallpaper",
        images: ["/images/7_jesusWallpaper.jpg"],
        link: "https://play.google.com/store/apps/details?id=lifetimeinfotech.jesus.hdwallpaper",
      },
      {
        title: "Buddha HD Photo Wallpapers",
        images: ["/images/8_buddhaWallpaper.jpg"],
        link: "https://play.google.com/store/apps/details?id=lifetimeinfotech.buddha.hdwallpaper",
      },
      {
        title: "Nature HD Photo Wallpaper",
        images: ["/images/9_natureWallpaper.jpg"],
        link: "https://play.google.com/store/apps/details?id=lifetimeinfotech.nature.hdwallpaper",
      },
      {
        title: "Flowers Wallpaper 4K-HD Photos",
        images: ["/images/10_flowerWallpaper.jpg"],
        link: "https://play.google.com/store/apps/details?id=lifetimeinfotech.flowerplant.wallpaper",
      },
      {
        title: "Ganesh Wallpaper HD 4K Images",
        images: ["/images/11_Ganesh.jpg"],
        link: "https://play.google.com/store/apps/details?id=lifetimeinfotech.ganesh.hdwallpaper",
      },
      {
        title: "Shiva HD Photo Wallpaper",
        images: ["/images/12_shiv.jpg"],
        link: "https://play.google.com/store/apps/details?id=lifetimeinfotech.shiv.hdwallpaper",
      },
      {
        title: "Ram Sita HD Photo Wallpapers",
        images: ["/images/13_ram.jpg"],
        link: "https://play.google.com/store/apps/details?id=lifetimeinfotech.ram.hdwallpaper",
      },
      {
        title: "Hanuman HD Photo Wallpapers",
        images: ["/images/14_hanuman.jpg"],
        link: "https://play.google.com/store/apps/details?id=lifetimeinfotech.hanuman.hdwallpaper",
      },
      {
        title: "Swaminarayan Photo Wallpapers",
        images: ["/images/15_swaminaryan.jpg"],
        link: "https://play.google.com/store/apps/details?id=lifetimeinfotech.swaminarayan.hdwallpape",
      },
      {
        title: "Krishna HD Photo Wallpapers",
        images: ["/images/16_krishna.jpg"],
        link: "https://play.google.com/store/apps/details?id=lifetimeinfotech.krishna.wallpaper",
      },
      {
        title: "Ronaldo CR7 Wallpaper HD 2024",
        images: ["/images/17_ronaldo.png"],
        link: "https://play.google.com/store/apps/details?id=lifetimeinfotech.ronaldo.wallpaper",
      },
      {
        title: "Lionel Messi HD Wallpaper 2024",
        images: ["/images/18_lionelmessi.png"],
        link: "https://play.google.com/store/apps/details?id=lifetimeinfotech.lionelmessi.wallpaper",
      },
      {
        title: "Neymar JR HD Wallpaper",
        images: ["/images/19_neymar.jpg"],
        link: "hhttps://play.google.com/store/apps/details?id=lifetimeinfotech.neymar.hdwallpaper",
      },
      {
        title: "John Cena HD Wallpaper 2024",
        images: ["/images/20_Johncena.png"],
        link: "https://play.google.com/store/apps/details?id=lifetimeinfotech.johncena.wallpaper",
      },
      {
        title: "Roman Reigns HD Wallpaper 2024",
        images: ["/images/21_romanreign.jpg"],
        link: "https://play.google.com/store/apps/details?id=lifetimeinfotech.romanreigns.wallpaper",
      },
      {
        title: "Basketball Wallpaper 4K - NBA",
        images: ["/images/22_NBA.jpg"],
        link: "https://play.google.com/store/apps/details?id=lifetimeinfotech.nba.hdwallpaper",
      },
      {
        title: "Motivational - Daily Quotes 4K",
        images: ["/images/23_motivational.jpg"],
        link: "https://play.google.com/store/apps/details?id=lifetimeinfotech.motivational.wallpaper",
      },
      {
        title: "Candlestick Patterns Charts",
        images: ["/images/24_stockmarket.jpg"],
        link: "https://play.google.com/store/apps/details?id=lifetimeinfotech.sharemarket.candlestickchart",
      },
      {
        title: "Food HD Wallpaper",
        images: ["/images/25_foodwallpaper.jpg"],
        link: "https://play.google.com/store/apps/details?id=lifetimeinfotech.food.hdwallpaper",
      },
      {
        title: "Sunset HD Wallpaper & 4K Photo",
        images: ["/images/26_sunset.jpg"],
        link: "https://play.google.com/store/apps/details?id=lifetimeinfotech.sunset.hdwallpaper",
      },
      {
        title: "Stone HD Wallpaper",
        images: ["/images/27_stone.jpg"],
        link: "https://play.google.com/store/apps/details?id=lifetimeinfotech.stone.hdwallpaper",
      },
      {
        title: "Home Front Elevation Designs",
        images: ["/images/28_elevation.jpg"],
        link: "https://play.google.com/store/apps/details?id=lifetimeinfotech.elevation_design.wallpaper",
      },
      {
        title: "Kitchen Design Ideas & Decor",
        images: ["/images/29_kitchen.png"],
        link: "https://play.google.com/store/apps/details?id=lifetimeinfotech.kitchendesign.wallpaper",
      },
      {
        title: "Bedroom Interior Design Ideas",
        images: ["/images/30_bedroom.jpg"],
        link: "https://play.google.com/store/apps/details?id=lifetimeinfotech.bedroomdesign.wallpaper",
      },
      {
        title: "TV Shelves and TV Unit design",
        images: ["/images/31_tvshalve.jpg"],
        link: "https://play.google.com/store/apps/details?id=lifetimeinfotech.tvshelve_design.wallpaper",
      },
      {
        title: "Animal Wallpaper HD | 4K Photo",
        images: ["/images/32_animal.jpg"],
        link: "https://play.google.com/store/apps/details?id=lifetimeinfotech.animal.wallpaper",
      },
      {
        title: "Car HD Wallpaper",
        images: ["/images/33_car.jpg"],
        link: "https://play.google.com/store/apps/details?id=lifetimeinfotech.car.wallpaper",
      },
      {
        title: "Bike Wallpaper HD | 4K | Photo",
        images: ["/images/34_bike.jpg"],
        link: "https://play.google.com/store/apps/details?id=lifetimeinfotech.bike.wallpaper",
      },
      {
        title: "Cricket HD Photo Wallpaper",
        images: ["/images/35_cricket.jpg"],
        link: "https://play.google.com/store/apps/details?id=lifetimeinfotech.cricket.hd_wallpapers",
      },
      {
        title: "Photo Pose Photography Ideas",
        images: ["/images/36_photopose.jpg"],
        link: "https://play.google.com/store/apps/details?id=lifetimeinfotech.photopose.wallpapers",
      },
      {
        title: "Football HD Wallpaper",
        images: ["/images/37_footballer.jpg"],
        link: "https://play.google.com/store/apps/details?id=lifetimeinfotech.footballer.wallpapers",
      },
    ],
    Web: [
      {
        title: "lifetimecreation.in",
        images: ["/images/web/lifetime/4.png"],
        link: "https://www.lifetimecreation.in/",
      },
      {
        title: "embroiderybazar.in",
        images: ["/images/web/embroiderybazar/1.png"],
        link: "https://embroiderybazar.in/",
      },
      {
        title: "shreegruhlaxmiurban.in",
        images: ["/images/web/gruhlaxmi/1.png"],
        link: "https://shreegruhlaxmiurban.in/",
      },
      {
        title: "shreevaibhavlaxmimahilaurban.in",
        images: ["/images/web/vaibhavlaxmi/3.png"],
        link: "https://shreevaibhavlaxmimahilaurban.in/",
      },
      {
        title: "dhanlaxmiurban.in",
        images: ["/images/web/dhanlaxmi/1.png"],
        link: "https://www.dhanlaxmiurban.in/",
      },
    ],
    UIUX: [
      {
        title: "Cafery",
        images: [
          "/images/figma/cafery/1.png",
          "/images/figma/cafery/2.png",
          "/images/figma/cafery/3.png",
        ],
        link: "#",
      },
      {
        title: "Caprisun",
        images: [
          "/images/figma/caprisun/12.jpg",
          "/images/figma/caprisun/13.jpg",
          "/images/figma/caprisun/14.jpg",
          "/images/figma/caprisun/15.jpg",
        ],
        link: "#",
      },
      {
        title: "Embroidery Machine",
        images: [
          "/images/figma/Embroidery Machine/2.jpg",
          "/images/figma/Embroidery Machine/3.jpg",
          "/images/figma/Embroidery Machine/4.jpg",
          "/images/figma/Embroidery Machine/7.jpg",
        ],
        link: "#",
      },
      {
        title: "Food App",
        images: [
          "images/figma/Food App/13.jpg",
          "images/figma/Food App/14.jpg",
          "images/figma/Food App/15.jpg",
          "images/figma/Food App/16.jpg",
        ],
        link: "#",
      },
      {
        title: "Life TimeCreation",
        images: [
          "/images/figma/Life TimeCreation/2.jpg",
          "/images/figma/Life TimeCreation/3.jpg",
          "/images/figma/Life TimeCreation/5.jpg",
          "/images/figma/Life TimeCreation/7.jpg",
        ],
        link: "#",
      },
    ],
  };

  const [category, setCategory] = useState("Mobile");
  const [showAll, setShowAll] = useState(false);
  const [lightbox, setLightbox] = useState({
    open: false,
    images: [],
    index: 0,
  });

  useEffect(() => {
    AOS.refreshHard();
  }, [category]);

  const openLightbox = (images, index = 0) => {
    setLightbox({ open: true, images, index });
  };

  const closeLightbox = () => {
    setLightbox({ open: false, images: [], index: 0 });
  };

  const nextImage = () => {
    setLightbox((prev) => ({
      ...prev,
      index: (prev.index + 1) % prev.images.length,
    }));
  };

  const prevImage = () => {
    setLightbox((prev) => ({
      ...prev,
      index: (prev.index - 1 + prev.images.length) % prev.images.length,
    }));
  };

  useEffect(() => {
    const handleKey = (e) => {
      if (!lightbox.open) return;
      if (e.key === "ArrowRight") nextImage();
      if (e.key === "ArrowLeft") prevImage();
      if (e.key === "Escape") closeLightbox();
    };
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [lightbox]);

  useEffect(() => {
    if (location.hash) {
      const hash = location.hash.replace("#", "").toLowerCase();
      if (hash === "mobile") setCategory("Mobile");
      if (hash === "web") setCategory("Web");
      if (hash === "uiux") setCategory("UIUX");
    }
  }, [location]);

  useEffect(() => {
    setShowAll(false);
  }, [category]);

  useEffect(() => {
    document.body.style.overflow = lightbox.open ? "hidden" : "unset";
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [lightbox.open]);

  const visibleData = showAll ? data[category] : data[category].slice(0, 12);

  return (
    <section className="p-folio">
      <div className="p-folio__hero" data-aos="fade-down">
        <h1 className="p-folio__title">Our Global Portfolio</h1>
        <p className="p-folio__subtitle">
          A fine presentation of modern engineering, innovative interfaces, and
          functional designs.
        </p>

        {/* CATEGORY SELECTOR TABS */}
        <div className="p-folio__tabs">
          {["Mobile", "Web", "UIUX"].map((tab) => (
            <button
              key={tab}
              className={`p-folio__tab-btn ${category === tab ? "is-active" : ""}`}
              onClick={() => setCategory(tab)}
            >
              {tab === "UIUX"
                ? "UI/UX Concept"
                : tab === "Web"
                  ? "Web Development"
                  : "Mobile Apps"}
            </button>
          ))}
        </div>
      </div>

      {/* CORE DISPLAY GRID */}
      <div className="p-folio__grid" key={category}>
        {visibleData.map((item, index) => {
          const mainImage = item.images[0];
          return (
            <div className="p-folio__card" key={index} data-aos="zoom-in-up">
              <div
                className="p-folio__card-media"
                onClick={() => openLightbox(item.images, 0)}
              >
                <img
                  src={mainImage}
                  alt={item.title}
                  className="p-folio__card-img"
                />
                <div className="p-folio__card-overlay">
                  <span className="p-folio__card-zoom-icon">
                    🔍 View Showcase
                  </span>
                </div>

                {item.images.length > 1 && (
                  <div className="p-folio__card-gallery-nav">
                    <button
                      className="p-folio__card-nav-arrow"
                      onClick={(e) => {
                        e.stopPropagation();
                        openLightbox(item.images, 0);
                      }}
                    >
                      ❮
                    </button>
                    <button
                      className="p-folio__card-nav-arrow"
                      onClick={(e) => {
                        e.stopPropagation();
                        openLightbox(item.images, 1);
                      }}
                    >
                      ❯
                    </button>
                  </div>
                )}
              </div>

              <div className="p-folio__card-details">
                <h3 className="p-folio__card-title">{item.title}</h3>
                {category !== "UIUX" && (
                  <a
                    href={item.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="p-folio__card-cta"
                  >
                    {category === "Mobile"
                      ? "Install App →"
                      : "Visit Website →"}
                  </a>
                )}
              </div>
            </div>
          );
        })}
      </div>

      {/* SHOW MORE CONTROLS */}
      {data[category].length > 12 && (
        <div className="p-folio__footer-actions">
          <button
            className="p-folio__load-btn"
            onClick={() => setShowAll(!showAll)}
          >
            {showAll ? "Show Less ↑" : "Show More ↓"}
          </button>
        </div>
      )}

      {/* REACT PORTAL LIGHTBOX - Mounts completely outside parent styling containers */}
      {lightbox.open &&
        createPortal(
          <div className="p-folio-modal" onClick={closeLightbox}>
            <button className="p-folio-modal__dismiss" onClick={closeLightbox}>
              ✕ Close
            </button>

            <div
              className="p-folio-modal__wrapper"
              onClick={(e) => e.stopPropagation()}
            >
              {lightbox.index > 0 && (
                <button
                  className="p-folio-modal__nav p-folio-modal__nav--left"
                  onClick={prevImage}
                >
                  ❮
                </button>
              )}

              <div className="p-folio-modal__screen">
                <img
                  src={lightbox.images[lightbox.index]}
                  alt="Showcase detail presentation"
                  className="p-folio-modal__viewport-img"
                />
              </div>

              {lightbox.index < lightbox.images.length - 1 && (
                <button
                  className="p-folio-modal__nav p-folio-modal__nav--right"
                  onClick={nextImage}
                >
                  ❯
                </button>
              )}
            </div>

            <div className="p-folio-modal__counter">
              Project Image {lightbox.index + 1} of {lightbox.images.length}
            </div>
          </div>,
          document.body,
        )}
    </section>
  );
};

export default Portfolio;
